/* Échantillons dans le panier — voir snippets/echantillons-panier.liquid
   V29 (03/11/2026) — 1 offert par crème ou lotion seule, par encens (bakhoor, oliban) et par brûleur Subitism
   (calcul fait par le site ; le secours droitLocal applique la même règle).
   V26 (03/11/2026) — TOUS LES OFFERTS SONT CHOISIS PAR NOUS : plus d'offert au choix (CHOIX_MAX = 0) ; le droit
   entier devient la ligne « Surprise » choisie par l'équipe ; tout échantillon choisi par le client est payant.
   Payants sans limite : la même référence peut être reprise (le menu la repropose, − / + sur la ligne).
   V25 (02/11/2026) — PAS D'OFFERT SUR LE PARFUM COMMANDÉ : l'échantillon d'un parfum présent dans le panier
   (même maison + même nom) est toujours « Payant » et ne compte pas dans les au choix offerts ; dans le menu,
   ce parfum est signalé « Votre parfum · en supplément ».
   V24 (02/11/2026) — AU CHOIX + SURPRISE, 5 OFFERTS MAXIMUM :
   - Offerts = droit calculé par le site (5 au plus). On alterne au choix / surprise, 2 au choix au maximum :
     1 → 1 au choix · 2 → 1 + 1 surprise · 3 → 2 + 1 · 4 → 2 + 2 · 5 → 2 + 3.
   - La surprise est UNE ligne « Offert » (quantité = nombre de surprises) dont la propriété Parfum vaut
     « Surprise » ; elle est ajoutée, ajustée ou retirée d'office par le contrôle, jamais par le client.
   - Les échantillons choisis sont « Offert » dans la limite des « au choix », « Payant » au-delà.
   - Le menu ne propose que les parfums disponibles (index templates/collection.echantillons.liquid).
   V23 (31/10/2026) — PAS D'ÉCHANTILLON SANS ACHAT, et un contrôle qui ne peut plus être pris en défaut :
   - Recherche dans tout le catalogue de parfums et ajout d'un échantillon par parfum choisi.
   - Les échantillons sont « Offert » (0 €) dans la limite du droit calculé par le site, « Payant » au-delà.
   - Si le panier ne contient plus que des échantillons, ils sont retirés (on ne vend pas d'échantillon seul).
   - Le contrôle relit toujours le VRAI panier (cart.js) et le droit recalculé par le site (rendu de la section
     du tiroir), jamais l'écran. Une seule vérification à la fois ; si le panier change pendant qu'elle tourne,
     elle recommence. Plus aucune limite de corrections (c'était la faille de la commande #2620).
   - Le clic sur « Passer la commande » passe par la même vérification (assets/echantillons-ordre.js).
   - Sur la commande, chaque échantillon ne porte QUE « Parfum » et « Maison » (lisible pour la préparation) ;
     la photo affichée dans le panier est retrouvée dans le catalogue d'après ces deux informations. */
(function () {
  if (window.__odoEchantillons) return;
  window.__odoEchantillons = true;

  var CACHE_KEY = 'odoEchCatalogue-v2';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var HANDLE = 'echantillon';
  var SECTION = 'cart-drawer';
  var MAX_OFFERTS = 5;
  var CHOIX_MAX = 0;
  var SURPRISE = 'Surprise';
  var UN_OFFERT = ['Crème & Lotion', 'Soin corps', 'Encens', 'Encensoir'];
  var catalogue = null;
  var loading = null;
  var busy = false;
  var scanTimer = null;
  var deco = document.createElement('textarea');

  function dec(s) { deco.innerHTML = String(s); return deco.value; }
  function norm(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
  function keyOf(maison, parfum) { return norm(maison).trim() + '|' + norm(parfum).trim(); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function hl(text, q) {
    if (!q) return esc(text);
    var i = norm(text).indexOf(q);
    if (i < 0) return esc(text);
    return esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + q.length)) + '</mark>' + esc(text.slice(i + q.length));
  }

  function loadCatalogue() {
    if (catalogue) return Promise.resolve(catalogue);
    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) { catalogue = JSON.parse(cached); return Promise.resolve(catalogue); }
    } catch (e) {}
    if (loading) return loading;
    var url = function (p) { return ROOT + 'collections/all?view=echantillons&page=' + p; };
    loading = fetch(url(1)).then(function (r) { return r.json(); }).then(function (first) {
      var reqs = [];
      for (var p = 2; p <= (first.pages || 1); p++) reqs.push(fetch(url(p)).then(function (r) { return r.json(); }).then(function (d) { return d.items || []; }));
      return Promise.all(reqs).then(function (rest) {
        var items = first.items || [];
        rest.forEach(function (a) { items = items.concat(a); });
        var seen = {};
        items = items.filter(function (x) { if (!x || !x.h || seen[x.h]) return false; seen[x.h] = 1; return true; });
        items.forEach(function (x) { x.s = norm(x.n + ' ' + x.v); });
        items.sort(function (a, b) { return a.v.localeCompare(b.v, 'fr') || a.n.localeCompare(b.n, 'fr'); });
        catalogue = items;
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(items)); } catch (e) {}
        return items;
      });
    }).catch(function () { loading = null; return null; });
    return loading;
  }

  /* Répartition des offerts : au choix (2 au plus) puis surprises */
  function repartition(entitled) {
    var choix = Math.min(Math.ceil(entitled / 2), CHOIX_MAX);
    return { choix: choix, surprise: Math.max(0, entitled - choix) };
  }
  function estSurprise(it) { return !!(it && it.properties && String(it.properties.Parfum || '') === SURPRISE); }
  function nomProduit(t) { return String(t || '').split(' – ')[0].trim(); }
  /* Clés « maison|parfum » des parfums achetés dans le panier réel */
  function clesAchats(items) {
    var k = {};
    items.forEach(function (it) { if (it.handle !== HANDLE) k[keyOf(it.vendor, nomProduit(it.product_title))] = 1; });
    return k;
  }
  function estPropre(it, cles) { var p = it.properties || {}; return !!cles[keyOf(p.Maison, p.Parfum)]; }
  function handlesAchats(box) { var o = {}; String(box.dataset.own || '').split(',').forEach(function (h) { if (h) o[h] = 1; }); return o; }

  function boxOf(el) { return el && el.closest ? el.closest('[data-ech]') : null; }

  /* Seules « Parfum » et « Maison » sont gardées (les anciennes lignes techniques sont abandonnées) */
  function propsOf(l) {
    var raw = {};
    try { raw = JSON.parse(l.dataset.props || '{}'); } catch (e) {}
    var props = {};
    ['Parfum', 'Maison'].forEach(function (k) { if (raw[k] != null && raw[k] !== '') props[k] = dec(raw[k]); });
    return props;
  }
  function propsItem(it) {
    var props = {};
    var raw = it.properties || {};
    ['Parfum', 'Maison'].forEach(function (k) { if (raw[k] != null && raw[k] !== '') props[k] = String(raw[k]); });
    return props;
  }

  function lines(box) {
    return Array.prototype.map.call(box.querySelectorAll('.ech__line'), function (l) {
      return { key: l.dataset.key, qty: Number(l.dataset.qty || 1), free: l.dataset.kind === 'free', surprise: l.dataset.kind === 'surprise', props: propsOf(l) };
    });
  }

  function counts(box) {
    var free = 0, total = 0;
    lines(box).forEach(function (l) { if (l.surprise) return; total += l.qty; if (l.free) free += l.qty; });
    var entitled = Number(box.dataset.entitled || 0);
    var choix = box.dataset.choix != null ? Number(box.dataset.choix) : repartition(entitled).choix;
    return { free: free, total: total, entitled: entitled, choix: choix, achat: Number(box.dataset.achat || 0) };
  }

  function render(box) {
    var input = box.querySelector('.ech__input');
    var list = box.querySelector('.ech__list');
    if (!input || !list) return;
    var q = norm(input.value.trim());
    if (!catalogue) { list.innerHTML = '<li class="ech__empty">Chargement des parfums…</li>'; return; }
    if (!q) { list.innerHTML = '<li class="ech__empty">Tapez le nom d’un parfum ou d’une maison</li>'; return; }
    var picked = {};
    lines(box).forEach(function (l) { picked[keyOf(l.props.Maison, l.props.Parfum)] = 1; });
    var words = q.split(/\s+/).filter(Boolean);
    var res = catalogue.filter(function (x) { return words.every(function (w) { return x.s.indexOf(w) > -1; }); }).slice(0, 40);
    var first = words[0];
    var prix = box.dataset.prix || '';
    list.innerHTML = res.length ? res.map(function (x, i) {
      return '<li class="ech__opt' + (i === 0 ? ' is-active' : '') + '" role="option" data-handle="' + esc(x.h) + '">' +
        (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy" width="44" height="44">' : '<span class="ech__img"></span>') +
        '<span><span class="ech__v">' + hl(x.v, first) + '</span><span class="ech__n">' + hl(x.n, first) + '</span></span>' +
        '<span class="ech__add">' + (picked[keyOf(x.v, x.n)] ? 'Encore un' : 'Ajouter') + (prix ? ' · ' + esc(prix) : '') + '</span></li>';
    }).join('') : '<li class="ech__empty">Aucun parfum trouvé</li>';
  }

  /* Photo des échantillons choisis, retrouvée dans le catalogue */
  function fill(box) {
    var holes = box.querySelectorAll('.ech__line .ech__img');
    if (!holes.length) return;
    loadCatalogue().then(function (cat) {
      if (!cat || !box.isConnected) return;
      var map = {};
      cat.forEach(function (x) { map[keyOf(x.v, x.n)] = x; });
      Array.prototype.forEach.call(holes, function (hole) {
        var p = propsOf(hole.closest('.ech__line'));
        var x = map[keyOf(p.Maison, p.Parfum)];
        if (!x || !x.i || !hole.isConnected) return;
        var img = document.createElement('img');
        img.src = x.i; img.alt = ''; img.width = 56; img.height = 56; img.loading = 'lazy';
        hole.replaceWith(img);
      });
    });
  }

  function open(box) {
    if (!box || !box.querySelector('.ech__input')) return;
    box.classList.add('is-open');
    render(box);
    loadCatalogue().then(function () { if (box.isConnected) render(box); });
  }

  function refreshUI() {
    var page = document.querySelector('[data-ech].ech--page');
    if (page) { window.location.reload(); return; }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function api(path, data) {
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function getJSON(path) {
    return fetch(ROOT + path, { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); return r.json(); });
  }

  /* ---------- Le contrôle : panier réel + droit recalculé par le site ---------- */

  /* Droit aux offerts pour le panier ACTUEL, calculé par le site (snippet rendu à neuf dans la section du tiroir) */
  function droitSite() {
    /* en aperçu d'un thème non publié, la section doit venir de CE thème (sinon c'est le thème en ligne qui répond) */
    var th = window.Shopify && window.Shopify.theme;
    var apercu = th && th.role && th.role !== 'main' && th.id ? '&preview_theme_id=' + th.id : '';
    return getJSON('?sections=' + SECTION + apercu).then(function (j) {
      var html = j && j[SECTION];
      if (!html) throw new Error('section');
      var e = html.match(/data-entitled="(\d+)"/), f = html.match(/data-free="(\d+)"/), p = html.match(/data-paid="(\d+)"/);
      var c = html.match(/data-choix="(\d+)"/), su = html.match(/data-surprise="(\d+)"/);
      if (!e || !f || !p) throw new Error('droit');
      var r = repartition(Number(e[1]));
      return { entitled: Number(e[1]), free: Number(f[1]), paid: Number(p[1]), choix: c ? Number(c[1]) : r.choix, surprise: su ? Number(su[1]) : r.surprise };
    });
  }

  /* Secours si la section ne répond pas : même règle que le snippet (2 par flacon ≥ 30 ml, 1 par petit format
     ou pack, 1 par crème, encens ou Subitism, 5 maximum), sans les exclusions par produit qui ne sont connues que du site */
  function droitLocal(cart) {
    var box = document.querySelector('[data-ech]');
    var n = 0;
    (cart.items || []).forEach(function (it) {
      if (it.handle === HANDLE) return;
      var t = String(it.product_title || '').toLowerCase();
      var creme = it.product_type === 'Parfum' && t.indexOf('coffret') < 0 && /soin parfumé|crème corp|creme corp|lotion/.test(t);
      if (UN_OFFERT.indexOf(it.product_type) > -1 || creme) { n += it.quantity; return; }
      if (it.product_type !== 'Parfum' && it.product_type !== 'Coffret') return;
      var vt = String(it.variant_title || '').toLowerCase();
      var ml = parseFloat(vt.replace('ml', '').replace(',', '.'));
      var small = it.vendor === 'PACKS DECOUVERTES' || vt.indexOf(' x ') > -1 || (ml > 0 && ml < 30);
      n += small ? it.quantity : 2 * it.quantity;
    });
    var entitled = Math.min(n, MAX_OFFERTS), r = repartition(entitled);
    return {
      entitled: entitled, choix: r.choix, surprise: r.surprise,
      free: box ? Number(box.dataset.free) : 0,
      paid: box ? Number(box.dataset.paid) : 0
    };
  }

  function etat() {
    return getJSON('cart.js').then(function (cart) {
      return droitSite().catch(function () { return droitLocal(cart); }).then(function (d) { return { cart: cart, d: d }; });
    });
  }

  /* Ce qu'il faut changer pour que le panier respecte la règle (null = rien à faire) */
  function planifier(s) {
    var items = s.cart.items || [];
    var ech = items.filter(function (it) { return it.handle === HANDLE; });
    s.achat = items.some(function (it) { return it.handle !== HANDLE; });
    var updates = {}, adds = [];
    if (!s.achat) {
      if (!ech.length) return null;
      ech.forEach(function (it) { updates[it.key] = 0; });
      return { updates: updates, adds: adds, retire: true };
    }
    var d = s.d;
    if (!d.free || !d.paid) return null;
    var r = { choix: d.choix, surprise: d.surprise };
    if (r.choix == null || r.surprise == null) r = repartition(d.entitled);

    /* 1. Les surprises : une seule ligne « Offert », quantité = nombre de surprises */
    var sur = ech.filter(estSurprise);
    if (r.surprise <= 0) {
      sur.forEach(function (it) { updates[it.key] = 0; });
    } else if (sur.length === 1 && Number(sur[0].variant_id) === d.free) {
      if (sur[0].quantity !== r.surprise) updates[sur[0].key] = r.surprise;
    } else {
      sur.forEach(function (it) { updates[it.key] = 0; });
      adds.push({ id: d.free, quantity: r.surprise, properties: { 'Parfum': SURPRISE } });
    }

    /* 2. Le parfum commandé n'est jamais offert : ses échantillons passent en « Payant » */
    var cles = clesAchats(items);
    ech.filter(function (it) { return !estSurprise(it) && estPropre(it, cles) && Number(it.variant_id) === d.free; }).forEach(function (it) {
      updates[it.key] = 0;
      adds.push({ id: d.paid, quantity: it.quantity, properties: propsItem(it) });
    });

    /* 3. Les autres échantillons choisis : « Offert » dans la limite des au choix, « Payant » au-delà */
    var choisis = ech.filter(function (it) { return !estSurprise(it) && !estPropre(it, cles); });
    var total = 0, free = 0;
    choisis.forEach(function (it) { total += it.quantity; if (Number(it.variant_id) === d.free) free += it.quantity; });
    var target = Math.min(r.choix, total);
    if (free > target) {
      var trop = free - target;
      choisis.filter(function (it) { return Number(it.variant_id) === d.free; }).reverse().forEach(function (it) {
        if (trop <= 0) return;
        var k = Math.min(it.quantity, trop);
        updates[it.key] = it.quantity - k;
        adds.push({ id: d.paid, quantity: k, properties: propsItem(it) });
        trop -= k;
      });
    } else if (free < target) {
      var manque = target - free;
      choisis.filter(function (it) { return Number(it.variant_id) !== d.free; }).forEach(function (it) {
        if (manque <= 0) return;
        var k = Math.min(it.quantity, manque);
        updates[it.key] = it.quantity - k;
        adds.push({ id: d.free, quantity: k, properties: propsItem(it) });
        manque -= k;
      });
    }
    if (!Object.keys(updates).length && !adds.length) return null;
    return { updates: updates, adds: adds };
  }

  function appliquer(plan) {
    return api('cart/update.js', { updates: plan.updates }).then(function () {
      return plan.adds.length ? api('cart/add.js', { items: plan.adds }) : null;
    });
  }

  /* Corrige jusqu'à ce que le panier soit conforme (au plus 5 passes : un panier réel converge en 1 ou 2) */
  function boucle(n, change) {
    return etat().then(function (s) {
      var plan = planifier(s);
      if (!plan || n >= 5) return { achat: s.achat, change: change, conforme: !plan };
      return appliquer(plan).then(function () { return boucle(n + 1, true); });
    });
  }

  var enCours = null, encore = false;
  /* Une seule vérification à la fois ; si on la redemande pendant qu'elle tourne, elle repart à la fin */
  function verifier() {
    if (enCours) { encore = true; return enCours; }
    var p = boucle(0, false).then(function (res) {
      enCours = null;
      if (encore) { encore = false; return verifier().then(function (r2) { r2.change = r2.change || res.change; return r2; }); }
      return res;
    }, function (err) { enCours = null; encore = false; throw err; });
    enCours = p;
    return p;
  }
  window.odoEchVerifier = verifier;

  function controler() {
    verifier().then(function (res) { if (res.change) refreshUI(); }, function () {});
  }

  /* ---------- Actions de l'écran ---------- */

  function run(box, job) {
    if (busy) return;
    busy = true;
    box.classList.add('is-busy');
    job().catch(function () {}).then(function () { return verifier().catch(function () {}); }).then(function () {
      busy = false;
      refreshUI();
      setTimeout(function () { box.classList.remove('is-busy'); }, 1500);
    });
  }

  function add(box, handle) {
    var item = (catalogue || []).filter(function (x) { return x.h === handle; })[0];
    if (!item) return;
    var c = counts(box);
    if (!c.achat) return; // pas d'échantillon sans achat
    var propre = !!handlesAchats(box)[item.h];
    var variant = (!propre && c.free < c.choix) ? box.dataset.free : box.dataset.paid;
    var props = { 'Parfum': item.n, 'Maison': item.v };
    run(box, function () { return api('cart/add.js', { items: [{ id: Number(variant), quantity: 1, properties: props }] }); });
  }

  function remove(box, key) {
    run(box, function () { return api('cart/change.js', { id: key, quantity: 0 }); });
  }

  /* À chaque nouvel affichage du bloc (le panier a changé), on contrôle le vrai panier */
  function scan() {
    scanTimer = null;
    var boxes = document.querySelectorAll('[data-ech]');
    var nouveau = false;
    boxes.forEach(function (box) {
      fill(box);
      if (!box.dataset.checked) { box.dataset.checked = '1'; nouveau = true; }
    });
    if (nouveau && !busy) controler();
  }

  document.addEventListener('focusin', function (e) {
    if (e.target.classList && e.target.classList.contains('ech__input')) open(boxOf(e.target));
  });

  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('ech__input')) render(boxOf(e.target));
  });

  document.addEventListener('focusout', function (e) {
    if (!(e.target.classList && e.target.classList.contains('ech__input'))) return;
    var box = boxOf(e.target);
    setTimeout(function () { if (box && !box.contains(document.activeElement)) box.classList.remove('is-open'); }, 200);
  });

  document.addEventListener('mousedown', function (e) {
    if (e.target.closest && e.target.closest('.ech__opt')) e.preventDefault();
  });

  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('.ech__opt');
    if (opt) { e.preventDefault(); add(boxOf(opt), opt.dataset.handle); return; }
    var x = e.target.closest && e.target.closest('.ech__x');
    if (x) { e.preventDefault(); remove(boxOf(x), x.dataset.key); return; }
    var qb = e.target.closest && e.target.closest('.ech__q');
    if (qb) {
      e.preventDefault();
      var n = Math.max(0, Number(qb.dataset.q) || 0);
      run(boxOf(qb), function () { return api('cart/change.js', { id: qb.dataset.key, quantity: n }); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!(e.target.classList && e.target.classList.contains('ech__input'))) return;
    var box = boxOf(e.target);
    var opts = box.querySelectorAll('.ech__opt');
    var cur = box.querySelector('.ech__opt.is-active');
    var idx = Array.prototype.indexOf.call(opts, cur);
    if (e.key === 'Enter') {
      e.preventDefault();
      if (cur) add(box, cur.dataset.handle);
    } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      if (!opts.length) return;
      var next = e.key === 'ArrowDown' ? Math.min(idx + 1, opts.length - 1) : Math.max(idx - 1, 0);
      if (cur) cur.classList.remove('is-active');
      opts[next].classList.add('is-active');
      opts[next].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Escape') {
      e.target.blur();
    }
  });

  /* Un panier modifié ailleurs (fiche produit, autre onglet revenu au premier plan) est contrôlé aussi */
  document.addEventListener('cart:change', function () { if (!busy) setTimeout(controler, 300); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) controler(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && document.querySelector('[data-ech]')) controler(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(function (muts) {
    if (scanTimer) return;
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { scanTimer = setTimeout(scan, 80); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
